import React from 'react';
import { defineMessages } from 'react-intl';

import StandardAlert from '../StandardAlert';

const messages = defineMessages({
  header: {
    defaultMessage: 'No Answers Selected',
  },
  message: {
    defaultMessage: 'Please answer question before submitting your feedback.',
  },
  confirm: {
    defaultMessage: 'OK',
  },
});

export default props => <StandardAlert {...props} messages={messages} config={{ buttons: 1 }} />;
